import { controls, grouped } from "../controls";
const daily_attendances = {
    label: "Daily Attendances",
    pageLabel: "Daily Attendances", starting: true, url: "autogen",
    formActions: { edit: { allow: true }, delete: { allow: true } },
    pageType: "history",
    filter: [
        ...controls.displayText({ tab: "filter", label: "Employee" }),
        ...controls.oc({ tab: "filter", c: "Employee", placeHolder: "Employee Code", name: "DailyAttendance-employee-employee_code", fastpath: "employees" }),
        ...controls.showData({ tab: "filter", displaytype: "capital", data: "DailyAttendance-employee-employee_display" }),
    ]
    , form: [
        ...controls.displayText({ tab: "general", label: "Employee", star: false }),
        ...controls.oc({ tab: "general", c: "Employee", placeHolder: "Employee Code", name: "employee_code", fastpath: "employees", hidden: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "employee_display" }),
        ...controls.magicDateLabel({ tab: "general", label: "In Time", target: "in_time", star: false }),
        ...controls.magicDate({ tab: "general", name: "in_time", dateType: "ontype", displayFormat: "dd/MM/yyyy HH:mm:ss" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.magicDateLabel({ tab: "general", label: "Out Time", target: "out_time", star: false }),
        ...controls.magicDate({ tab: "general", name: "out_time", dateType: "ontype", displayFormat: "dd/MM/yyyy HH:mm:ss" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "in branch Id", star: false }),
        ...controls.oc({ tab: "general", length: 4, c: "Branch", placeHolder: "in branch Id", name: "in_branch_code", fastpath: "branches", hidden: false, displayData: { branch_display: "in_branch_display" } }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "in_branch_display" }),
        ...controls.displayText({ tab: "general", label: "out branch Id", star: false }),
        ...controls.oc({ tab: "general", length: 4, c: "Branch", placeHolder: "out branch Id", name: "out_branch_code", fastpath: "branches", hidden: false, displayData: { branch_display: "out_branch_display" } }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "out_branch_display" }),
    ]
    , history: {
        perPage: 10,
        reportHeader: "Daily Attendances",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        clickable: true,
        displayColumns: [
            { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
            { Header: "Name as on ID", accessor: "DailyAttendance-employee-employee_display", },
            { Header: "In Time", accessor: "in_time", type: 'date' },
            { Header: "Out Time", accessor: "out_time", type: 'date' },
            { Header: "Branch", accessor: "DailyAttendance-in_branch-branch_display", },
            { Header: "Branch", accessor: "DailyAttendance-out_branch-branch_display", },
        ]
    }
};
export default daily_attendances;